(function () {
  'use strict';

  var root = document.getElementById('AlgoliaShopAll');
  if (!root) return;

  var cfg;
  try {
    cfg = JSON.parse(document.getElementById('AlgoliaShopAllConfig').textContent);
  } catch (e) {
    return;
  }

  if (!cfg.appId || !cfg.apiKey) {
    root.querySelector('[data-algolia-setup]').hidden = false;
    return;
  }

  var money = new Intl.NumberFormat(cfg.locale || 'en-GB', {
    style: 'currency',
    currency: cfg.currency || 'GBP',
  });

  function esc(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }

  // Algolia image URLs are Shopify CDN URLs, which accept a _{width}x size suffix.
  function sizedImage(url, width) {
    if (!url) return null;
    return url.replace(/(\.(?:png|jpe?g|webp|gif))(\?|$)/i, '_' + width + 'x$1$2');
  }

  // These are string templates, so highlighting has to come from the raw
  // _highlightResult value. instantsearch's Highlight component returns a VNode,
  // which would stringify to "[object Object]" here. The value is already escaped
  // by Algolia and wrapped in the index's <em> highlight tags.
  function highlight(hit, attribute) {
    var result = hit._highlightResult && hit._highlightResult[attribute];
    return result && result.value ? result.value : esc(hit[attribute]);
  }

  function hitTemplate(hit) {
    var handle = hit.handle;
    var url = handle ? cfg.rootUrl + 'products/' + handle + '?variant=' + encodeURIComponent(hit.objectID) : '#';
    var image = sizedImage(hit.product_image || hit.image, 400);
    var price = typeof hit.price === 'number' ? hit.price : hit.variants_min_price;
    var compareAt = hit.compare_at_price;
    var onSale = typeof compareAt === 'number' && compareAt > 0 && price != null && compareAt > price;

    return [
      '<a class="algolia-hit__link" href="' + esc(url) + '">',
      '<div class="algolia-hit__media">',
      image
        ? '<img class="algolia-hit__image" src="' + esc(image) + '" alt="' + esc(hit.title) + '" loading="lazy" width="400" height="400">'
        : '<span class="algolia-hit__image algolia-hit__image--empty" aria-hidden="true"></span>',
      hit.inventory_available === false ? '<span class="algolia-hit__badge">Out of stock</span>' : '',
      '</div>',
      '<div class="algolia-hit__body">',
      hit.vendor ? '<p class="algolia-hit__vendor">' + esc(hit.vendor) + '</p>' : '',
      '<h3 class="algolia-hit__title">' + highlight(hit, 'title') + '</h3>',
      hit.sku ? '<p class="algolia-hit__sku">SKU ' + esc(hit.sku) + '</p>' : '',
      '<p class="algolia-hit__price">',
      price != null ? esc(money.format(price)) : '',
      onSale ? ' <s class="algolia-hit__compare">' + esc(money.format(compareAt)) + '</s>' : '',
      '</p>',
      '</div>',
      '</a>',
    ].join('');
  }

  var search = instantsearch({
    indexName: cfg.indexName,
    searchClient: algoliasearch(cfg.appId, cfg.apiKey),
    routing: true,
    future: { preserveSharedStateOnUnmount: true },
  });

  var configureParams = { hitsPerPage: cfg.hitsPerPage };
  if (cfg.distinct) configureParams.distinct = true;

  var widgets = [
    instantsearch.widgets.configure(configureParams),

    instantsearch.widgets.searchBox({
      container: '#algolia-searchbox',
      placeholder: cfg.placeholder,
      showSubmit: false,
      showReset: true,
      cssClasses: { input: 'field__input algolia-searchbox__input' },
    }),

    instantsearch.widgets.stats({
      container: '#algolia-stats',
      templates: {
        text: function (data) {
          var count = data.nbHits.toLocaleString(cfg.locale || 'en-GB');
          return count + (data.nbHits === 1 ? ' product' : ' products');
        },
      },
    }),

    instantsearch.widgets.sortBy({
      container: '#algolia-sortby',
      items: cfg.sortItems,
      cssClasses: { select: 'select__select algolia-sortby__select' },
    }),

    instantsearch.widgets.currentRefinements({
      container: '#algolia-current-refinements',
    }),

    instantsearch.widgets.clearRefinements({
      container: '#algolia-clear-refinements',
      templates: { resetLabel: 'Clear all filters' },
      cssClasses: { button: 'button button--secondary algolia-clear__button' },
    }),

    instantsearch.widgets.hits({
      container: '#algolia-hits',
      templates: {
        item: hitTemplate,
        empty:
          '<div class="algolia-empty">' +
          '<p>No products match your search.</p>' +
          '<p>Try a broader term, or clear a filter or two.</p>' +
          '</div>',
      },
    }),

    instantsearch.widgets.pagination({
      container: '#algolia-pagination',
      padding: 2,
      showFirst: false,
      showLast: false,
    }),
  ];

  if (cfg.showInStockToggle) {
    widgets.push(
      instantsearch.widgets.toggleRefinement({
        container: '#algolia-instock',
        attribute: 'inventory_available',
        on: true,
        templates: { labelText: 'In stock only' },
      })
    );
  }

  cfg.facets.forEach(function (facet) {
    widgets.push(
      instantsearch.widgets.panel({
        templates: { header: function () { return esc(facet.label); } },
        hidden: function (options) { return options.items.length === 0; },
      })(instantsearch.widgets.refinementList)({
        container: '#algolia-facet-' + facet.attribute.replace(/[^a-z0-9]/gi, '-'),
        attribute: facet.attribute,
        limit: facet.limit,
        showMore: true,
        showMoreLimit: facet.showMoreLimit,
        searchable: facet.searchable,
        searchablePlaceholder: 'Search ' + facet.label.toLowerCase(),
        sortBy: ['count:desc', 'name:asc'],
      })
    );
  });

  if (cfg.showPriceRange) {
    widgets.push(
      instantsearch.widgets.panel({
        templates: { header: function () { return 'Price'; } },
      })(instantsearch.widgets.rangeInput)({
        container: '#algolia-facet-price',
        attribute: 'price',
        templates: { separatorText: 'to', submitText: 'Apply' },
        cssClasses: { submit: 'button button--secondary' },
      })
    );
  }

  search.addWidgets(widgets);
  search.start();

  // Mobile filter drawer.
  var toggle = root.querySelector('[data-algolia-filter-toggle]');
  var panel = root.querySelector('[data-algolia-filters]');
  if (toggle && panel) {
    toggle.addEventListener('click', function () {
      var open = panel.hasAttribute('data-open');
      if (open) {
        panel.removeAttribute('data-open');
      } else {
        panel.setAttribute('data-open', '');
      }
      toggle.setAttribute('aria-expanded', String(!open));
    });
  }
})();
